var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "video-camera-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.071,
    height: 9.545,
    viewBox: "0 0 15.071 9.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13754",
    "data-name": "Path 13754",
    d: "M18.55,54.512V60.54a1.006,1.006,0,0,1-1,1H10.512A2.515,2.515,0,0,1,8,59.033V53a1.006,1.006,0,0,1,1-1h7.033A2.515,2.515,0,0,1,18.55,54.512Zm4.271-1.188a.5.5,0,0,0-.5,0l-2.512,1.435a.5.5,0,0,0-.253.436v3.158a.5.5,0,0,0,.253.436l2.512,1.435a.5.5,0,0,0,.752-.436V53.758a.5.5,0,0,0-.25-.435Z",
    transform: "translate(-8 -52)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/video-on.951a3c64.svg";
export { ForwardRef as ReactComponent };